<template>
  <v-autocomplete
    ref="patientAutocomplete"
    v-model="selectedPatientModel"
    label="Patient ID *"
    :items="availablePatients"
    :hide-no-data="!search"
    :search-input.sync="search"
    :no-filter="true"
    :error-messages="errorMessages"
    @blur="$emit('blur')"
  >
    <!-- new patient creation-->
    <template #no-data>
      <v-list-item data-e2e-id="create-new-patient" @click.stop.prevent="createNewPatient">
        <span
          ><span class="action">Create new patient: </span><strong>{{ search }}</strong></span
        >
      </v-list-item>
    </template>
    <!-- selected patient -->
    <template #selection="{ item }">
      <span v-if="item">{{ item.firstName }} {{ item.lastName }} {{ item.externalId }}</span>
    </template>
    <!-- available patients -->
    <template #item="{ item }">
      <v-layout v-if="item && item.externalId">
        <v-flex>{{ item.firstName }} {{ item.lastName }} {{ item.externalId }}</v-flex>
        <v-flex class="text-right">
          {{ caseCount(item) }}
        </v-flex>
      </v-layout>
      <div v-else data-e2e-id="create-new-patient" @click.stop.prevent="createNewPatient">
        <span
          ><span class="action">Create new patient: </span><strong>{{ search }}</strong></span
        >
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    patients: { type: Array, required: true },
    selectedPatient: { type: Object, default: () => {} },
    patientIdToCaseExternalIds: { type: Object, default: () => {} },
    errorMessages: { type: Array, default: () => [] }
  },
  data() {
    return {
      search: null
    }
  },
  computed: {
    selectedPatientModel: {
      get() {
        return this.selectedPatient
      },
      set(patient) {
        this.$emit('selectedPatientChange', patient)
      }
    },
    availablePatients() {
      if (!_.isEmpty(this.patients)) {
        if (!this.exactMatchFound) {
          return _.concat([this.search], this.patients)
        }
        return this.patients
      } else if (_.isNull(this.search) && !_.isNil(this.selectedPatientModel)) {
        return [this.selectedPatientModel]
      } else {
        return []
      }
    },
    exactMatchFound() {
      return (
        _.find(
          this.patients,
          patient => _.toLower(patient.externalId) === _.toLower(this.search)
        ) !== undefined
      )
    }
  },
  watch: {
    async search() {
      this.$emit('patientSearchChanged', this.search)
    }
  },
  methods: {
    validateLength(searchText) {
      return searchText && searchText.length > 2 && searchText.length <= 200
    },
    createNewPatient() {
      this.selectedPatientModel = this.search
      this.blurPatientAutocomplete()
    },
    caseCount(patient) {
      const caseExternalIds = this.patientIdToCaseExternalIds[patient.id] || []
      return caseExternalIds.length === 1
        ? `${caseExternalIds.length} case`
        : `${caseExternalIds.length} cases`
    },
    blurPatientAutocomplete() {
      this.$refs.patientAutocomplete.blur()
    }
  }
}
</script>

<style lang="scss" scoped>
.action {
  color: var(--v-primary-base);
}
</style>
